export default __webpack_public_path__ + "static/media/DetectiveBlue.06670681.png";